import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../lib/auth.js';

const NAV = [
  { to: '/journeys', label: 'Journeys', icon: '◈' },
  // The client does not want a separate Category concept, and calls goals "categories".
  // The route, the API and the database still say "goal" — only the wording changed here.
  { to: '/goals', label: 'Categories', icon: '◎' },
  { to: '/users', label: 'App users', icon: '◍' },
  { to: '/feedback', label: 'Feedback', icon: '✎' },
  { to: '/waitlist', label: 'Waitlist', icon: '◇' },
];

export function Shell({
  title,
  subtitle,
  actions,
  children,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  const { admin, signOut } = useAuth();

  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">
          <div className="brand-mark" aria-hidden="true">
            M
          </div>
          <div>
            <div className="brand-name">Manasil</div>
            <div className="brand-sub">Studio</div>
          </div>
        </div>

        <nav className="nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
            >
              <span className="nav-icon" aria-hidden="true">
                {item.icon}
              </span>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-foot">
          <div className="who">
            <div className="who-name">{admin?.name}</div>
            <div className="who-role">{admin?.role}</div>
          </div>
          <button type="button" className="btn btn-ghost btn-sm" onClick={signOut}>
            Sign out
          </button>
        </div>
      </aside>

      <main className="main">
        <header className="topbar">
          <div className="grow">
            <h1>{title}</h1>
            {subtitle ? <p className="topbar-sub">{subtitle}</p> : null}
          </div>
          {actions}
        </header>
        <div className="page">{children}</div>
      </main>
    </div>
  );
}
